/**
 * @generated SignedSource<<abc532ac3b862400f0a9a84e6ef9dad5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductFilterInput = {
  isActive?: boolean | null | undefined;
  isAvailable?: boolean | null | undefined;
  isTemporary?: boolean | null | undefined;
  query?: string | null | undefined;
  slug?: string | null | undefined;
};
export type AppQuery_Query$variables = {
  filterBy?: ProductFilterInput | null | undefined;
  limit?: number | null | undefined;
  orderBy?: ReadonlyArray<ReadonlyArray<string | null | undefined> | null | undefined> | null | undefined;
  page?: number | null | undefined;
};
export type AppQuery_Query$data = {
  readonly store: {
    readonly " $fragmentSpreads": FragmentRefs<"App_store">;
  };
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"App_viewer" | "CartSubstitutions_viewer" | "SearchBar_viewer">;
  } | null | undefined;
};
export type AppQuery_Query = {
  response: AppQuery_Query$data;
  variables: AppQuery_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterBy"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v4 = {
  "kind": "Variable",
  "name": "filterBy",
  "variableName": "filterBy"
},
v5 = {
  "kind": "Variable",
  "name": "limit",
  "variableName": "limit"
},
v6 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v7 = {
  "kind": "Variable",
  "name": "page",
  "variableName": "page"
},
v8 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadline",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickup",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickupStart",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickupStreet",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickupZip",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v16 = {
  "kind": "Literal",
  "name": "first",
  "value": 10000
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v20 = [
  {
    "kind": "Literal",
    "name": "filterBy",
    "value": {
      "isActive": true
    }
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "package",
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qty",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "App_viewer"
          },
          {
            "args": (v8/*: any*/),
            "kind": "FragmentSpread",
            "name": "CartSubstitutions_viewer"
          },
          {
            "args": (v8/*: any*/),
            "kind": "FragmentSpread",
            "name": "SearchBar_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "App_store"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AppQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Coop",
            "kind": "LinkedField",
            "name": "coop",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "announcement",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Cycle",
                "kind": "LinkedField",
                "name": "currentCycle",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pickupEnd",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveryStatus",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Cycle",
                "kind": "LinkedField",
                "name": "nextCycle",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isBanned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "owed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "owedReason",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "credit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filterBy",
                "value": {
                  "isActive": true,
                  "parentId": 0
                }
              },
              (v16/*: any*/)
            ],
            "concreteType": "CategoryConnection",
            "kind": "LinkedField",
            "name": "categories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": (v20/*: any*/),
                        "concreteType": "CategoryConnection",
                        "kind": "LinkedField",
                        "name": "categories",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CategoryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Category",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v20/*: any*/),
                                    "concreteType": "CategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "categories",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CategoryEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Category",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v10/*: any*/),
                                              (v18/*: any*/),
                                              (v19/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "categories(filterBy:{\"isActive\":true})"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "categories(filterBy:{\"isActive\":true})"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "categories(filterBy:{\"isActive\":true,\"parentId\":0},first:10000)"
          },
          {
            "alias": null,
            "args": [
              (v4/*: any*/),
              (v16/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "concreteType": "ProductConnection",
            "kind": "LinkedField",
            "name": "products",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rank",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": (v25/*: any*/),
                        "concreteType": "ImageConnection",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "previewUrl",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "images(first:1)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Category",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClearanceItem",
                        "kind": "LinkedField",
                        "name": "UNSAFE_clearanceItem",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          (v10/*: any*/),
                          (v26/*: any*/),
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SpecialItem",
                        "kind": "LinkedField",
                        "name": "UNSAFE_specialItem",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          (v10/*: any*/),
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Cart",
            "kind": "LinkedField",
            "name": "cart",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subtotal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v16/*: any*/)
                ],
                "concreteType": "CartItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CartItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CartItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Substitution",
                            "kind": "LinkedField",
                            "name": "substitutions",
                            "plural": true,
                            "selections": [
                              (v10/*: any*/),
                              (v17/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "substitutionId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "clearanceItemId",
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "specialItemId",
                            "storageKey": null
                          },
                          (v27/*: any*/),
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v15/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Category",
                                "kind": "LinkedField",
                                "name": "category",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": (v25/*: any*/),
                                "concreteType": "ImageConnection",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ImageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          (v10/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "images(first:1)"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:10000)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Message",
                "kind": "LinkedField",
                "name": "messages",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "details",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "persists",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "dc1c02cf5ebe7ff9ebde4d5bdabe91bc",
    "id": null,
    "metadata": {},
    "name": "AppQuery_Query",
    "operationKind": "query",
    "text": "query AppQuery_Query(\n  $filterBy: ProductFilterInput\n  $orderBy: [[String]]\n  $page: Int\n  $limit: Int\n) {\n  viewer {\n    ...App_viewer\n    ...CartSubstitutions_viewer_31pPng\n    ...SearchBar_viewer_31pPng\n    id\n  }\n}\n\nfragment Announcement_viewer on Viewer {\n  coop {\n    announcement\n    currentCycle {\n      deadline\n      id\n    }\n    timezone\n    id\n  }\n}\n\nfragment App_viewer on Viewer {\n  coop {\n    announcement\n    currentCycle {\n      deadline\n      id\n    }\n    timezone\n    id\n  }\n  user {\n    isBanned\n    owed\n    owedReason\n    id\n  }\n  ...Announcement_viewer\n  ...Cart_viewer\n  ...Header_viewer\n}\n\nfragment CartSubstitutions_item on CartItem {\n  substitutions {\n    id\n    rowId\n    productId\n    substitutionId\n  }\n}\n\nfragment CartSubstitutions_product on Product {\n  productId\n  fullName\n}\n\nfragment CartSubstitutions_viewer_31pPng on Viewer {\n  id\n  categories(first: 10000, filterBy: {isActive: true, parentId: 0}) {\n    edges {\n      node {\n        id\n        rowId\n        name\n        slug\n        categories(filterBy: {isActive: true}) {\n          edges {\n            node {\n              id\n              rowId\n              name\n              slug\n            }\n          }\n        }\n      }\n    }\n  }\n  products(first: 10000, limit: $limit, page: $page, filterBy: $filterBy, orderBy: $orderBy) {\n    edges {\n      node {\n        id\n        productId\n        cost\n        unit\n        rank\n        fullName\n        package\n        images(first: 1) {\n          edges {\n            node {\n              previewUrl\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment Cart_viewer on Viewer {\n  ...CartSubstitutions_viewer_31pPng\n  coop {\n    currentCycle {\n      deadline\n      pickup\n      pickupStart\n      pickupEnd\n      id\n    }\n    timezone\n    id\n  }\n  cart {\n    id\n    qty\n    subtotal\n    items(first: 10000) {\n      edges {\n        node {\n          ...CartSubstitutions_item\n          clearanceItemId\n          id\n          specialItemId\n          total\n          qty\n          product {\n            ...CartSubstitutions_product\n            id\n            category {\n              slug\n              id\n            }\n            productId\n            fullName\n            package\n            images(first: 1) {\n              edges {\n                node {\n                  url\n                  id\n                }\n              }\n            }\n          }\n          substitutions {\n            id\n          }\n        }\n      }\n    }\n  }\n  user {\n    credit\n    role\n    id\n  }\n}\n\nfragment Deadlines_viewer on Viewer {\n  coop {\n    currentCycle {\n      deadline\n      pickup\n      pickupStart\n      pickupStreet\n      pickupZip\n      deliveryStatus\n      id\n    }\n    nextCycle {\n      deadline\n      pickup\n      pickupStart\n      pickupStreet\n      pickupZip\n      id\n    }\n    id\n  }\n  user {\n    role\n    id\n  }\n}\n\nfragment DesktopHeader_viewer on Viewer {\n  ...HeaderCategories_viewer\n  ...Deadlines_viewer\n  ...Navigation_viewer\n  ...SearchBar_viewer_31pPng\n  user {\n    firstName\n    role\n    isBanned\n    owed\n    owedReason\n    id\n  }\n  cart {\n    qty\n    id\n  }\n}\n\nfragment HeaderCategories_viewer on Viewer {\n  categories(first: 10000, filterBy: {isActive: true, parentId: 0}) {\n    edges {\n      node {\n        id\n        name\n        slug\n        categories(filterBy: {isActive: true}) {\n          edges {\n            node {\n              id\n              name\n              slug\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment Header_viewer on Viewer {\n  ...DesktopHeader_viewer\n  ...MobileHeader_viewer\n}\n\nfragment MobileHeader_viewer on Viewer {\n  categories(first: 10000, filterBy: {isActive: true, parentId: 0}) {\n    edges {\n      node {\n        id\n        name\n        slug\n        categories(filterBy: {isActive: true}) {\n          edges {\n            node {\n              id\n              name\n              slug\n              categories(filterBy: {isActive: true}) {\n                edges {\n                  node {\n                    id\n                    name\n                    slug\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  cart {\n    qty\n    id\n  }\n  user {\n    role\n    isBanned\n    owed\n    owedReason\n    id\n  }\n}\n\nfragment Navigation_viewer on Viewer {\n  user {\n    firstName\n    role\n    id\n  }\n  cart {\n    qty\n    id\n  }\n}\n\nfragment ProductItem_cart on Cart {\n  id\n}\n\nfragment ProductItem_cartItem on CartItem {\n  id\n  qty\n}\n\nfragment ProductItem_viewer on Viewer {\n  user {\n    id\n    role\n    email\n    firstName\n    fullName\n  }\n}\n\nfragment SearchBar_viewer_31pPng on Viewer {\n  ...ProductItem_viewer\n  products(first: 10000, limit: $limit, page: $page, filterBy: $filterBy, orderBy: $orderBy) {\n    edges {\n      node {\n        id\n        productId\n        cost\n        unit\n        rank\n        fullName\n        package\n        images(first: 1) {\n          edges {\n            node {\n              previewUrl\n              id\n            }\n          }\n        }\n        category {\n          rowId\n          name\n          slug\n          id\n        }\n        UNSAFE_clearanceItem {\n          cost\n          id\n          qty\n          unit\n        }\n        UNSAFE_specialItem {\n          cost\n          id\n          unit\n        }\n      }\n    }\n    total\n  }\n  cart {\n    ...ProductItem_cart\n    items(first: 10000) {\n      edges {\n        node {\n          ...ProductItem_cartItem\n          product {\n            id\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5cba8c4bb74e002a7b514650932615ae";

export default node;
